export default __webpack_public_path__ + "static/media/websitevideos.ea47ff79.png";